module.exports = __webpack_public_path__ + "img/symbol_7.3bac1066.png";